import { API_URLS } from "@/constants";
import apiRequest from "@/lib/axios";
import { CrmNotification, RecipientScope } from "@/types";

// Send a CRM notification to the picked agent and (optionally) their downline.
export const sendCrmNotification = async (data: {
  agentId: string;
  scope: RecipientScope;
  title: string;
  message: string;
}): Promise<{ delivered: number }> => {
  return apiRequest({
    method: "POST",
    url: API_URLS.CRM_NOTIFICATION.SEND,
    data,
    errorMessage: "Failed to send the notification. Please try again.",
  });
};

// The signed-in admin's own notifications (header bell list).
export const getMyCrmNotifications = async (): Promise<CrmNotification[]> => {
  return apiRequest({
    method: "GET",
    url: API_URLS.CRM_NOTIFICATION.LIST,
    errorMessage: "Failed to load notifications. Please try again.",
  });
};

export const getCrmUnreadCount = async (): Promise<{ count: number }> => {
  return apiRequest({
    method: "GET",
    url: API_URLS.CRM_NOTIFICATION.UNREAD_COUNT,
    errorMessage: "Failed to load the notification count. Please try again.",
  });
};

export const markCrmViewed = async (id: string): Promise<CrmNotification> => {
  return apiRequest({
    method: "PATCH",
    url: API_URLS.CRM_NOTIFICATION.VIEWED(id),
    errorMessage: "Failed to update the notification. Please try again.",
  });
};

export const markAllCrmRead = async (): Promise<{ modified: number }> => {
  return apiRequest({
    method: "PATCH",
    url: API_URLS.CRM_NOTIFICATION.READ_ALL,
    errorMessage: "Failed to update notifications. Please try again.",
  });
};

export const removeCrmNotification = async (id: string): Promise<CrmNotification> => {
  return apiRequest({
    method: "DELETE",
    url: API_URLS.CRM_NOTIFICATION.REMOVE(id),
    errorMessage: "Failed to delete the notification. Please try again.",
  });
};
